import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "form",
  id: "form"
}
const _hoisted_2 = { class: "form__title" }
const _hoisted_3 = { class: "form__paragraph" }
const _hoisted_4 = { class: "input__el--textarea__len" }
const _hoisted_5 = {
  key: 2,
  class: "error",
  style: {"margin-top":"12px"}
}

import {ref, computed, reactive} from 'vue'
import axios from 'axios';
import {useRouter} from 'vue-router';
import {useStore} from 'vuex';
import BaseInput from '@/components/Base/BaseInput.vue';
import BasePhone from '@/components/Base/BasePhone.vue';
import BaseButton from '@/components/Base/BaseButton.vue';
import {useI18n} from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const {t, locale} = useI18n()
const router = useRouter()
const store = useStore()

const agencyId = computed(() => {
  return store.state.pageContent.external_id ?? ''
})

const isComment = ref(false);
const commentLen = ref(0);

const formValues = reactive({
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  comment: '',
  agency: agencyId,
  language: locale
})

const formError = ref('')
const errorName = ref('')
const errorLastName = ref('')
const errorMail = ref('')
const errorTel = ref('')
const isLoading = ref(false)

const validateInput = (target) => {
  if (target.type === 'text') {
    if (!target.value.length) {
      if (target.name === 'first_name') {
        errorName.value = 'form.error.empty'
      } else {
        errorLastName.value = 'form.error.empty'
      }
    } else {
      if (target.name === 'first_name') {
        errorName.value = ''
      } else {
        errorLastName.value = ''
      }
    }
  }

  if (target.type === 'email') {
    if (!target.value.length) {
      errorMail.value = 'form.error.empty'
    } else {
      let isValidMail = target.value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (!isValidMail) {
        errorMail.value = 'form.error.invalid-email'
      } else {
        errorMail.value = ''
      }
    }
  }
}

function validateTelInput(target) {
  if (!target.value.length) {
    errorTel.value = 'form.error.empty'
  } else {
    let isValidTel = target.value.match(/\d{9,}/)
    if (!isValidTel) {
      errorTel.value = 'form.error.invalid-tel'
    } else {
      errorTel.value = ''
    }
  }
}

function submitForm() {
  for (const [key, value] of Object.entries(formValues)) {
    if (key == 'lastName') {
      if (value.length < 3) {
        errorLastName.value = 'form.error.empty'
        continue
      }
    } else if (key == 'name') {
      if (value.length < 3) {
        errorName.value = 'form.error.empty'
        continue
      }

    } else if (key == 'mail') {
      if (!value) {
        errorMail.value = 'form.error.empty'
        continue
      }
      let isValidMail = value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (!isValidMail) {
        errorMail.value = 'form.error.invalid-email'
        continue
      }
    } else if (key == 'phone') {
      if (!value) {
        errorTel.value = 'form.error.empty'
        continue
      }
      let isValidTel = value.match(/\d{9,}/)
      if (!isValidTel) {
        errorTel.value = 'form.error.invalid-tel'
        continue
      }
    }
  }

  if (errorMail.value || errorName.value || errorLastName.value || errorTel.value) {
    return
  }

  formError.value = ''
  isLoading.value = true
  axios.post(`${process.env.VUE_APP_BE_API_URL}/recompensate/`, {
    "agency": formValues.agency.toString(),
    "language": formValues.language === 'cz' ? formValues.language = 'cs' : formValues.language.toString(),
    "comment": formValues.comment.toString(),
    "first_name": formValues.first_name.toString(),
    "last_name": formValues.last_name.toString(),
    "phone": ('+' + formValues.phone).toString(),
    "email": formValues.email.toString(),
  })
      .then(() => {
        router.push('/thank-you')
      })
      .catch(err => {
        if(err.response.data.phone) {
          errorTel.value = 'form.error.invalid-tel'
        } else {
          formError.value = t("form.error.global")
        }
        isLoading.value = false
      })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("form.title")), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("form.paragraph")), 1),
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (submitForm()), ["prevent"]))
    }, [
      _createVNode(BaseInput, {
        name: "first_name",
        label: _unref(t)("form.name"),
        type: "text",
        placeholder: _unref(t)("form.name"),
        value: formValues.first_name,
        error: errorName.value,
        onInputChange: _cache[0] || (_cache[0] = (val) => formValues.first_name = val),
        onInputBlur: _cache[1] || (_cache[1] = (target) => validateInput(target))
      }, null, 8, ["label", "placeholder", "value", "error"]),
      _createVNode(BaseInput, {
        name: "last_name",
        label: _unref(t)("form.second_name"),
        type: "text",
        placeholder: _unref(t)("form.second_name"),
        value: formValues.last_name,
        error: errorLastName.value,
        onInputChange: _cache[2] || (_cache[2] = (val) => formValues.last_name = val),
        onInputBlur: _cache[3] || (_cache[3] = (target) => validateInput(target))
      }, null, 8, ["label", "placeholder", "value", "error"]),
      _createVNode(BasePhone, {
        name: "phone",
        label: _unref(t)("form.number"),
        value: formValues.phone,
        error: errorTel.value,
        onInputBlur: _cache[4] || (_cache[4] = (target) => validateTelInput(target)),
        onInputChange: _cache[5] || (_cache[5] = (val) => formValues.phone = val)
      }, null, 8, ["label", "value", "error"]),
      _createVNode(BaseInput, {
        name: "email",
        label: _unref(t)("form.mail.label"),
        type: "email",
        placeholder: _unref(t)("form.mail.placeholder"),
        value: formValues.email,
        error: errorMail.value,
        onInputChange: _cache[6] || (_cache[6] = (val) => formValues.email = val),
        onInputBlur: _cache[7] || (_cache[7] = (target) => validateInput(target))
      }, null, 8, ["label", "placeholder", "value", "error"]),
      (!isComment.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "form__button",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (isComment.value = true))
          }, " + " + _toDisplayString(_unref(t)("form.comment.btn")), 1))
        : _createCommentVNode("", true),
      (isComment.value)
        ? (_openBlock(), _createBlock(BaseInput, {
            key: 1,
            label: _unref(t)("form.comment.label"),
            "label-sm": _unref(t)("form.comment.label-sm"),
            type: "textarea",
            placeholder: _unref(t)("form.comment.placeholder"),
            value: formValues.comment,
            onInputChange: _cache[9] || (_cache[9] = (val) => {
                    commentLen.value = val.length;
                    formValues.comment = val;
                }),
            error: errorTel.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(commentLen.value) + "/500", 1)
            ]),
            _: 1
          }, 8, ["label", "label-sm", "placeholder", "value", "error"]))
        : _createCommentVNode("", true),
      _createVNode(BaseButton, {
        innerHTML: isLoading.value ? "<div class=loader></div>" : _unref(t)("form.btn")
      }, null, 8, ["innerHTML"]),
      (formError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(formError.value), 1))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})